import React, { useRef, useState } from "react";
import cn from "classnames";
import Modal from "../components/Modal";
import TextBox from "../components/TextBox";
import { ApiClient } from "../ApiClient";
import styles from "./TipFriend.module.scss";
const apiClient = new ApiClient("/api/notifications");
export function TipFriend({ strings, productId, productSource }) {
    const [isOpen, setIsOpen] = useState(false);
    const [recipientEmail, setRecipientEmail] = useState("");
    const [greetings, setGreetings] = useState("");
    const formRef = useRef(null);
    function onModalClose() {
        setRecipientEmail("");
        setGreetings("");
        setIsOpen(false);
    }
    async function send() {
        var _a, _b;
        if ((_b = !((_a = formRef.current) === null || _a === void 0 ? void 0 : _a.reportValidity())) !== null && _b !== void 0 ? _b : true) {
            return;
        }
        const data = {
            recipientEmail,
            greetings,
            productId,
            productSource,
        };
        await apiClient.post("/tip-friend", data);
        onModalClose();
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("button", { className: styles.tipFriendBtn, "data-source": productSource, onClick: () => setIsOpen(true) },
            React.createElement("div", { className: styles.iconWrapper },
                React.createElement("span", { className: cn("icomoon-envelope", styles.icon) })),
            React.createElement("span", { className: styles.tipFriendBtnText }, strings.label)),
        React.createElement(Modal, { isOpen: isOpen, onClose: onModalClose, title: strings.label, okBtnLabel: strings.okBtnLabel, onOk: send },
            React.createElement("form", { ref: formRef, className: styles.content },
                React.createElement("div", { className: styles.inputGroup },
                    React.createElement("label", null, "Send til:"),
                    React.createElement(TextBox, { type: "email", required: true, value: recipientEmail, setValue: setRecipientEmail })),
                React.createElement("div", { className: styles.greetingsGroup },
                    React.createElement("label", null, "Skriv eventuell hilsen eller annen informasjon:"),
                    React.createElement(TextBox, { required: true, value: greetings, setValue: setGreetings, multiline: true }))))));
}
